class ManualSlider {
  constructor(container) {
    this.container = container;
    this.slidesWrapper = container.querySelector(".slides-wrapper");
    this.slides = Array.from(container.querySelectorAll(".slide"));
    this.currentIndex = 0;

    this.prevButton = container.querySelector("#prevBtn");
    this.nextButton = container.querySelector("#nextBtn");
    this.closeButton = container.querySelector("#closeBtn");

    this.prevButton.addEventListener("click", () => this.showPreviousSlide());
    this.nextButton.addEventListener("click", () => this.showNextSlide());
    this.closeButton.addEventListener("click", () => this.hide());

    container
      .closest(".product-media-modal")
      .addEventListener("click", (event) => {
        if (!this.container.contains(event.target)) {
          this.hide();
        }
      });

    document.addEventListener("keydown", (event) => {
      if (!this.isOpen()) return;

      if (event.key === "ArrowRight") {
        event.preventDefault();
        this.showNextSlide();
      } else if (event.key === "ArrowLeft") {
        event.preventDefault();
        this.showPreviousSlide();
      } else if (event.key === "Escape") {
        this.hide();
      }
    });
  }

  isOpen() {
    return this.slidesWrapper.classList.contains("active");
  }

  showSlide(index) {
    if (index >= 0 && index < this.slides.length) {
      this.currentIndex = index;
      this.slidesWrapper.style.transform = `translateX(-${index * 100}%)`;

      this.slidesWrapper.classList.add("active");
      this.slides.forEach((slide, i) => {
        slide.classList.toggle("active", i === index);
      });
    }
  }

  hide() {
    this.slidesWrapper.classList.remove("active");
    this.slides.forEach((slide) => slide.classList.remove("active"));
  }

  showNextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  showPreviousSlide() {
    const prevIndex =
      (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.showSlide(prevIndex);
  }

  setActiveSlideByMediaId(mediaId) {
    const slide = this.slides.find(
      (slide) => slide.dataset.mediaId === mediaId
    );
    if (slide) {
      const index = this.slides.indexOf(slide);
      this.showSlide(index);
    }
  }
}

const sliderContainer = document.querySelector(".slider-container");
const manualSlider = new ManualSlider(sliderContainer);

function showActiveMedia(openedBy) {
  const mediaId = openedBy.getAttribute("data-media-id");
  manualSlider.setActiveSlideByMediaId(mediaId);
}

document.querySelectorAll("[data-media-id]").forEach((mediaElement) => {
  mediaElement.addEventListener("click", (event) => {
    showActiveMedia(event.currentTarget);
  });
});
